<svg viewBox="0 0 198 188" preserveAspectRatio="xMidYMid slice" role="img">
  <g stroke="none" stroke-width="1" fill="none" fill-rule="even-odd">
    <polygon [ngClass]="['star', estimateMark[type]]" points="99 154 40 185 51 119 4 73 69 64 99 3 128 64 194 73 147 119 158 185"></polygon>
  </g>
</svg>
